export class OperatingSystem {
  public static readonly Windows = 'Windows';
  public static readonly iOS = 'iOS';
  public static readonly macOS = 'macOS';
  public static readonly WINDOWS = 1;
  public static readonly MACOS = 2;
}
